import { skipperLinkAttributesToQuestion } from './attributes'
import { SkipperLinkAttributes, SkipperLinkQuestion } from './types'

export function onSkipperLinkClick({
  attributes,
  addQuestion
}: {
  attributes: SkipperLinkAttributes
  addQuestion: (
    question: SkipperLinkQuestion,
    positionShift?: number,
    onDoneCallback?: (id: string, questionView: { toggleCollapse: () => void }) => boolean,
    onFoundQuestionCallback?: (question: SkipperLinkQuestion) => void
  ) => void
}) {
  const question = skipperLinkAttributesToQuestion(attributes)

  if (Array.isArray(question)) {
    const prevQuestions: SkipperLinkQuestion[] = []

    const addNextQuestion = (questionIndex: number) => {
      const currentQuestion = question[questionIndex]
      const isLastQuestion = questionIndex === question.length - 1

      if (currentQuestion) {
        if ('function' == typeof currentQuestion) {
          const nextQuestionGenerator = currentQuestion
          let nextQuestion = nextQuestionGenerator(prevQuestions)
          if (nextQuestion) {
            nextQuestion = { ...nextQuestion }

            addQuestion(
              nextQuestion,
              questionIndex,
              (id, questionView) => {
                nextQuestion.id = id
                prevQuestions.push(nextQuestion)
                if (!isLastQuestion) {
                  setTimeout(() => questionView?.toggleCollapse?.(), 150)
                }
                setTimeout(() => addNextQuestion(questionIndex + 1), 300)
                return void 0 /* !isLastQuestion */
              },
              foundQuestion => {
                prevQuestions.push(foundQuestion)

                setTimeout(() => void addNextQuestion(questionIndex + 1), 300)
              }
            )
          }
        } else {
          const nextQuestion = { ...currentQuestion }
          addQuestion(
            nextQuestion,
            questionIndex,
            (id, questionView) => {
              nextQuestion.id = id
              prevQuestions.push(nextQuestion)
              if (!isLastQuestion) {
                setTimeout(() => questionView?.toggleCollapse?.(), 150)
              }
              setTimeout(() => void addNextQuestion(questionIndex + 1), 300)
              return void 0 /* !isLastQuestion */
            },
            foundQuestion => {
              prevQuestions.push(foundQuestion)

              setTimeout(() => void addNextQuestion(questionIndex + 1), 300)
            }
          )
        }
      }
    }

    addNextQuestion(0)
  } else {
    addQuestion(question)
  }
}

export function onSkipperLinkSCrollToQuestionClick({ id }: { id: string }) {
  StatPage?.view?.scrollToQuestion?.(id)
}
